import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import * as S from './styled';

const contentElement = (modalProps, children) => (
  <S.ModalRoute {...modalProps}>{children}</S.ModalRoute>
);
const overlayElement = (modalProps, children) => (
  <S.Overlay {...modalProps}>{children}</S.Overlay>
);

const ModalRoute = (props) => {
  return (
    <ReactModal
      contentElement={contentElement}
      overlayElement={overlayElement}
      isOpen
    >
      {props.children}
    </ReactModal>
  );
};

ModalRoute.propTypes = {
  children: PropTypes.node,
};

export default ModalRoute;
